import PickupDateSelector, {
  type PickupDateSelectorProps,
} from './pickup-date-selector';

const PickupDateSelectorButton = (props: PickupDateSelectorProps) => {
  return (
    <div className="p-0 h-fit border rounded-md">
      <PickupDateSelector {...props} />
    </div>
  );
};

export default PickupDateSelectorButton;
